import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { ScrollingModule as ExperimentalScrollingModule } from "@angular/cdk-experimental/scrolling";
import { PlanungAPIComponent } from "./planung-api.component";
import { PlanungApiNavigationComponent } from "./planung-api-navigation/planung-api-navigation.component";
import { PlanungApiTasksComponent } from "./planung-api-tasks/planung-api-tasks.component";
import { TaskInsertComponent } from "./planung-api-tasks/task-insert/task-insert.component";
import { TaskDetailComponent } from "./planung-api-tasks/task-detail/task-detail.component";
import { CommonComponentsModule } from "../common-components";
import { unsavedChangesGuard } from "../guards/unsaved-changes.guard";
import { TaskFormularCreateComponent } from "./planung-api-tasks/formular/create/task-formular-create.component";
import { TaskFormularTableComponent } from "./planung-api-tasks/formular/table/task-formular-table.component";
import { TaskFormularUpdateComponent } from "./planung-api-tasks/formular/update/task-formular-update.component";
import { PlanungApiTaskCardComponent } from "./planung-api-overview/task-card/task-card.component";
import { PlanungAPITaskCardTooltipComponent } from "./planung-api-overview/task-card/tooltip/task-card-tooltip.component";
import { PlanungApiOverviewComponent } from "./planung-api-overview/planung-api-overview.component";
import { PlanungApiPlanDropTargetComponent } from "./planung-api-overview/plan-drop-target/plan-drop-target.component";
import { PlanungApiTaskImportCsvComponent } from "./planung-api-tasks/import/task-import-csv.component";
import { PlanungApiProcessingOrderComponent } from "./processing-order/planung-processing-order.component";
import { PlanungApiTaskDragDropListComponent } from "./planung-api-overview/task-drag-drop-list/task-drag-drop-list.component";
import { PlanungApiOverviewNumberTaksCollectionComponent } from "./planung-api-overview/number-tasks-collection/number-tasks-collection.component";
import { CommonModule } from "@angular/common";
import { PlanungApiSchedulerCustomDayViewComponent } from "./planung-api-overview/plan-scheduler/custom-day-view/custom-day-view.component";
import { PlanungApiTaskListComponent } from "./planung-api-tasks/task-list/task-list.component";
import { PlanungApiTaskDetailModule } from "./planung-api-tasks/task-detail/task-detail.module";
import { PlanungApiTaskContactModule } from "./planung-api-tasks/task-contact/task-contact.module";
import { PlanungApiGuard } from "../guards";
import { NavRoutes } from "../services/cst-navigation.service";
import { TaskFormImagesGalleryModule } from "./planung-api-tasks/formular/images-gallery/form-images-gallery.module";
import { MatTabsModule } from "@angular/material/tabs";
import { CstCardTooltipDirective } from "./planung-api-overview/task-card/tooltip/task-card-tooltip.directive";
import { MatTableModule } from "@angular/material/table";
import { MatInputModule } from "@angular/material/input";
import { AdminCommonModule } from "src/app/administration/_common/admin-common.module";

const planungRoutes: Routes = [
  {
    path: "",
    component: PlanungAPIComponent,
    canActivate: [PlanungApiGuard],
    children: [
      {
        path: "",
        redirectTo: NavRoutes._PLANNING_OVERVIEW_R,
        pathMatch: "full",
      },
      {
        path: NavRoutes._PLANNING_OVERVIEW_R,
        component: PlanungApiOverviewComponent,
      },
      {
        path: NavRoutes._PLANNING_TASKS_R,
        component: PlanungApiTasksComponent,
      },
      {
        path: NavRoutes._PLANNING_TASKS_R + "/:id",
        component: TaskDetailComponent,
        canDeactivate: [unsavedChangesGuard],
      },
      {
        path: "auswertungen",
        loadChildren: () =>
          import("./reports/reports.module").then(
            (m) => m.PlanungReportsModule,
          ),
      },
      {
        path: "routen",
        component: PlanungApiProcessingOrderComponent,
        canDeactivate: [unsavedChangesGuard],
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    ScrollingModule,
    ExperimentalScrollingModule,
    CommonComponentsModule,
    RouterModule.forChild(planungRoutes),
    PlanungApiTaskDetailModule,
    PlanungApiTaskContactModule,
    TaskFormImagesGalleryModule,
    MatTabsModule,
    MatTableModule,
    MatInputModule,
    AdminCommonModule,
  ],
  declarations: [
    PlanungAPIComponent,
    PlanungApiNavigationComponent,
    PlanungApiOverviewComponent,
    PlanungApiTasksComponent,
    PlanungApiTaskCardComponent,
    PlanungAPITaskCardTooltipComponent,
    PlanungApiTaskListComponent,
    PlanungApiPlanDropTargetComponent,
    PlanungApiSchedulerCustomDayViewComponent,
    PlanungApiTaskImportCsvComponent,
    PlanungApiTaskDragDropListComponent,
    PlanungApiOverviewNumberTaksCollectionComponent,
    TaskInsertComponent,
    TaskFormularCreateComponent,
    TaskFormularUpdateComponent,
    TaskFormularTableComponent,
    TaskDetailComponent,
    CstCardTooltipDirective,
  ],
  exports: [
    RouterModule,
    PlanungApiTaskCardComponent,
    PlanungApiTaskDetailModule,
    TaskFormImagesGalleryModule,
    CommonComponentsModule,
    MatTabsModule,
    CstCardTooltipDirective,
  ],
})
export class PlanungApiRoutingModule {}
